import icon from "../../assets/rack.svg";
import type { Property } from "../../types";

export const mounting: Property = {
  id: "mounting",
  title: "mounting.title",
  icon,
};
